module.exports = __webpack_public_path__ + "img/foundation.48846fc4.png";